<template>

    <header class="header">
        <header_menu></header_menu>
        <hero v-if="!isValidView()" title="404 (page not found)" subtitle="Whoops! You've hit a 404 (page not found). Sorry, you'll have to turn around. " :hero_image="getHeroImage()" ></hero>
        <div v-if="!isValidView()" class="flex flex-col items-center"><button type="button" class="m-10 px-10 py-2 button button-pink-book" @click="home_Click()">Return to Home Page</button></div>
    </header>

    <main v-if="isValidView()" class="main">

        <div class="grid grid-cols-1 md:grid-cols-2">
            <h1 class="pl-4">Payment</h1>
            <basket_header :position=4></basket_header>
            <p class="mt-0 text-grey-default"></p>
        </div>

        <div class="row mt-16" :hidden="!Display_Agent_Payment_Summary()">
            <div class="cart-summary w-11/12 lg:w-8/12 xl:w-8/12 mx-auto">
                <div class="basket-summary border-aat-grey px-28 rounded-xl">
                    <payment_summary :isGross="selected_payment_method?.nett_gross"></payment_summary>
                    <payment_method ref="payment_method" @updateMethod="Update_Method"></payment_method>
                    <div v-if="selected_payment_method?.method == 'CC'"><payment_credit_card credit_card_div="payment-gateway-component" consumer_display="false"></payment_credit_card></div>
                    <div v-if="selected_payment_method?.method != 'CC'"><payment_confirmation @updatePayment="Update_Payment"></payment_confirmation></div>
                </div>
            </div>
        </div>

        <div :hidden="Display_Agent_Payment_Summary()"><payment_credit_card class="min-h-fit" credit_card_div="payment-gateway-component-consumer" consumer_display="true"></payment_credit_card></div>

        <div v-if="!isAgent_Login() && (GetBrand() == 'HEX' || GetBrand() == 'HAG')" class="flex items-center gap-3 max-w-2xl mx-4 md:mx-auto my-10 px-4 py-3 rounded-lg bg-blue-lighter">
            <svg class="w-5 h-5 flex-shrink-0 text-blue-default" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10"/>
                <line x1="12" y1="16" x2="12" y2="12"/>
                <line x1="12" y1="8" x2="12.01" y2="8"/>
            </svg>
            <p v-if="GetBrand() == 'HEX'" class="text-sm text-blue-darker">If you don't receive a confirmation email please contact us at <a href="mailto:info@highlandexplorertours.com" class="font-semibold underline">info@highlandexplorertours.com</a></p>
            <p v-if="GetBrand() == 'HAG'" class="text-sm text-blue-darker">If you don't receive a confirmation email please contact us at <a href="mailto:info@haggisadventures.com" class="font-semibold underline">info@haggisadventures.com</a></p>
        </div>

    </main>

    <footer_item></footer_item>

</template>

<script lang="ts" src="./4a_Payment.ts"></script>